<template>
  <div class="activity-list">
    <template v-if="activityList && activityList.length > 0">
      <div style="min-height: 400px;margin-bottom:20px;">
        <Row :gutter="30">
          <Col span="6" v-for="(item, index) in activityList" :key="'act-' + index" class="w-20">
            <div class="activity-list-one">
              <div class="activity-imgbox"> 
                <div class="activity-imgbox-brand" v-if="typeList[item.topicType] &&  item.topicType !== 0">
                  {{typeList[item.topicType]}}
                </div>
                <img v-if="item.banner && item.banner[0]" :src="item.banner[0]" />
                <img src="@/assets/img/empty.png" v-else />
              </div>
              <div class="activity-name" :title="item.name">{{item.name}}</div>
              <div class="activity-btn">
                <div class="txt" @click="linkTo(item)">编辑</div>
                <div class="activity-btn-line"></div>
                <div class="txt" @click="setTopic(item)">推荐</div>
                <div class="activity-btn-line"></div>
                <div class="txt">
                  <Dropdown trigger="custom" :visible="item.visible">
                    <a href="javascript:void(0);" style="color:#808080;" @click="toggleOpen(index)">
                      更多
                      <Icon type="ios-arrow-down"></Icon>
                    </a>
                    <DropdownMenu slot="list" style="text-align:center;">
                      <!-- <DropdownItem @click.native="exportInfo(item)">下载名单</DropdownItem> -->
                      <DropdownItem v-if="item.isShow" @click.native="setShow(item)">屏蔽</DropdownItem>
                      <DropdownItem v-if="!item.isShow" @click.native="setUnShow(item)">显示</DropdownItem>
                      <DropdownItem>
                        <Poptip
                          confirm
                          placement="top-start"
                          title="确认删除此展品吗 ?"
                          @on-ok="delItem(item, index)"
                          @on-cancel="handleClose(index)"
                        >
                          <div style="width: 100px;">删除</div>
                        </Poptip>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <div class="my-page" v-if="totalCount > pageSize" style="text-align:center;">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
    </template>
    <div v-else style="line-height:500px;text-align:center;">暂无数据</div>

    <!-- 修改展商置顶 -->
    <exTopic
      :show="editTopic"
      v-if="editTopic"
      @finish="init()"
      :editTopicnfo="editTopicnfo"
      @close="editTopic=false;editTopicnfo=null;"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import exTopic from "../components/ex-topic.vue";

export default {
  name: "host-activity-list",
  props: {
    search: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      editTopic: false,
      editTopicnfo: null,

      activityList: [], // 活动列表
      pageIndex: 1,
      pageSize: 12,
      totalCount: 0,
      typeList: [ 
        "不推荐",
        "推荐",
        "置顶",
      ],
    };
  },
  computed: {
    option() {
      return {
        ExhibitionId: this.exhibitionInfo.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "Name",
                  Value: `%${this.search}%`
                }
              }
            ]
          }
        }
      };
    },
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  components: {
    exTopic
  },
  methods: {
    ...mapActions({
      getActByExId: "hostActModule/getActByExId",
      editActTopic: "hostActModule/editActTopic",
      editActShow: "hostActModule/editActShow",
      delActById: "hostActModule/delActById"
    }),
    setTopic(item) {
      // 设置置顶
      this.editTopicnfo = item;
      this.editTopic = true;
    },
    async init() {
      let result = await this.getActByExId(this.option);
      if (result) {
        result.items.map(c => {
          if (c.banner) {
            c.banner = JSON.parse(c.banner);
          }
          c.visible = false;
        });
        this.activityList = result.items;
        this.pageSize = result.pageSize;
        this.pageIndex = result.pageIndex;
        this.totalCount = result.totalCount;
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    linkTo(item) {
      this.$router.push(`/host/index/act/act-edit?id=${item.id}`);
    },
    async setShow(item) {
      let req = {
        Id: item.id,
        IsShow: false
      };
      let result = await this.editActShow(req);
      if (result && result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    async setUnShow(item) {
      let req = {
        Id: item.id,
        IsShow: true
      };
      let result = await this.editActShow(req);
      if (result && result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    async delItem(item) {
      let result = await this.delActById(item.id);
      if (result && result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
      item.visible = false;
    },
    exportInfo(item) {
      console.log(item);
    },

    handleOpen(index) {
      this.activityList[index].visible = true;
    },
    handleClose(index) {
      this.activityList[index].visible = false;
    },
    toggleOpen(index) {
      let visible = this.activityList[index].visible;
      this.activityList[index].visible = !visible;
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.activity-list {
  min-width: 600px;
  padding: 30px 30px 100px 30px;
  &-one {
    background-color: #fff;
    margin-bottom: 20px;
    .activity-imgbox {
      width: 100%;
      padding-bottom: 66.666667%;
      position: relative;
      img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-height: 100%;
        z-index: 1;
      }
      &-brand {
        z-index: 2;
        position: absolute;
        top: 0;
        left: 0;
        padding: 3px 5px;
        color: #fff;
        background:#1890ff;
      }
    }
    .activity-name {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 10px 10px;
    }
    .activity-btn {
      font-size: 14px;
      height: 48px;
      text-align: center;
      color: #808080;
      cursor: pointer;
      display: flex;
      align-items: center;
      .txt {
        display: inline-block;
        width: 32%;
      }
      &-line {
        display: inline-block;
        width: 1px;
        height: 30px;
        background-color: #e8e8e8;
        padding-top: 18px;
      }
      &-del {
        height: 34px;
        padding: 7px 16px;
        color: #333;
        &:hover {
          background: #f3f3f3;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
</style>